export class InputMessageReturnDataParm{
  public txInformed: string;
  public isConfirm: boolean;
}
